import { useAuth } from "context/auth-context";
import { useCallback } from "react";
import { LabelType } from "screens/register/page-header";
import { APP_API_URL, StorageMobile } from "screens/register/util";
import { sourceMap } from "types/joinAsMemberMode";
import { AuthType } from "types/oauth";
import { CHOWBUS_API_URL, useHttp } from "utils/http";
import { defaultHeaders } from "utils/request";

export function useLoyaltyMemberService() {
    const client = useHttp();
    const { restaurant: restaurantData, restaurantLoyaltySetting, restaurantGroupInfo } = useAuth();

    const fetchLoyaltyMember = useCallback((lang: LabelType) => {
        const phoneNumber = StorageMobile("get") || "";
        if (restaurantGroupInfo) {

            return client(`${APP_API_URL}/api/${lang}/v1/restaurant_members/fetch`, {
                method: "post",
                data: {
                    phone_number: phoneNumber,
                    restaurant_id: restaurantData.data.id,
                    restaurant_group_id: restaurantGroupInfo.id,
                    role: "user",
                },
            })
        } else {
            return client(`${APP_API_URL}/api/${lang}/v1/restaurant_members/fetch`, {
                method: "post",
                data: {
                    phone_number: phoneNumber,
                    restaurant_id: restaurantData.data.id,
                    role: "user",
                },
            })
        }
        // eslint-disable-next-line
    }, [restaurantGroupInfo, restaurantData]);

    const fetchLoyaltyOrderAndTranscationList = useCallback((lang: LabelType, loyaltyMemberUUID: string) => {
        if (restaurantGroupInfo) {
            return Promise.allSettled([
                client(
                    `${APP_API_URL}/api/${lang}/v1/restaurant_members/${loyaltyMemberUUID}/orders`, {
                    method: "get",
                    data: {
                        restaurant_group_id: restaurantGroupInfo.id,
                        restaurant_id: restaurantData.data.id,
                    },
                }
                ),
                client(`${CHOWBUS_API_URL}/wallet/api/gift_card/v1/transactions`, {
                    method: "get",
                    params: {
                        customer_id: loyaltyMemberUUID,
                        customer_type: "RestaurantGroupMember",
                        restaurant_group_id: restaurantGroupInfo.id,
                        restaurant_id: restaurantData.data.id,
                    },
                }),]);
        } else {
            return Promise.allSettled([
                client(
                    `${APP_API_URL}/api/${lang}/v1/restaurant_members/${loyaltyMemberUUID}/orders`, {
                    method: "get",
                    data: {
                        restaurant_id: restaurantData.data.id,
                    },
                }
                ),
                client(`${CHOWBUS_API_URL}/wallet/api/gift_card/v1/transactions`, {
                    method: "get",
                    params: {
                        customer_id: loyaltyMemberUUID,
                        customer_type: "RestaurantMember",
                    },
                }),]);
        }

        // eslint-disable-next-line
    }, [restaurantGroupInfo, restaurantData]);

    const registerMember = useCallback((lang: LabelType, accessTokenData: AuthType, namePhone: {
        name: string;
        phone: string;
        email: string;
        birthday: string;
    }, deviceSystem: string, source: string) => {
        if (restaurantGroupInfo) {
            // 注册group餐厅会员
            return client(`${APP_API_URL}/api/${lang}/restaurant_group/v1/restaurant_group_members`, {
                method: "post",
                headers: {
                    Authorization: `${accessTokenData?.token_type} ${accessTokenData?.access_token}`,
                    ...defaultHeaders,
                },
                data: {
                    name: namePhone.name,
                    phone_number: namePhone.phone,
                    email: namePhone.email || '',
                    birthday: namePhone.birthday || '',
                    restaurant_id: restaurantData?.data?.id,
                    restaurant_group_id: restaurantGroupInfo.id,
                    device_system: deviceSystem,
                    language: lang,
                    source: sourceMap.get(source) || "loyalty_web",
                    deal_contract_id: restaurantLoyaltySetting?.loyaltyContractSetting?.deal_contract_id,
                    join_member_mode: restaurantLoyaltySetting?.loyaltyContractSetting?.join_member_mode,
                    from_web: true,
                },
            });
        } else {
            // 注册餐厅会员
            return client(`${APP_API_URL}/api/${lang}/v1/restaurant_members`, {
                method: "post",
                headers: {
                    Authorization: `${accessTokenData?.token_type} ${accessTokenData?.access_token}`,
                    ...defaultHeaders,
                },
                data: {
                    name: namePhone.name,
                    phone_number: namePhone.phone,
                    email: namePhone.email || '',
                    birthday: namePhone.birthday || '',
                    restaurant_id: restaurantData?.data?.id,
                    device_system: deviceSystem,
                    language: lang,
                    source: sourceMap.get(source) || "loyalty_web",
                },
            });
        }
        // eslint-disable-next-line
    }, [restaurantGroupInfo, restaurantData, restaurantLoyaltySetting]);


    const toggleLang = useCallback((lang: LabelType, phone_number: string,) => {
        if (restaurantGroupInfo) {
            return client(`${APP_API_URL}/api/${lang}/v1/restaurant_members/toggle_lang`, {
                method: "put",
                data: {
                    restaurant_group_id: restaurantGroupInfo.id,
                    phone_number,
                    restaurant_id: restaurantData.data.id,
                },
            });
        } else {
            return client(`${APP_API_URL}/api/${lang}/v1/restaurant_members/toggle_lang`, {
                method: "put",
                data: {
                    phone_number,
                    restaurant_id: restaurantData.data.id,
                },
            });
        }
        // eslint-disable-next-line
    }, [restaurantGroupInfo, restaurantData]);


    const startDownloadWalletCard = useCallback((lang: LabelType, phone_number: string,) => {
        if (restaurantGroupInfo) {
            // return Promise.resolve(null);
            return client(`${APP_API_URL}/api/${lang}/v1/restaurant_member_cards`, {
                method: "post",
                data: {
                    phone_number: phone_number,
                    restaurant_id: restaurantData.data.id,
                    restaurant_group_id: restaurantGroupInfo.id,
                },
                responseType: "arraybuffer",
            });
        } else {
            return client(`${APP_API_URL}/api/${lang}/v1/restaurant_member_cards`, {
                method: "post",
                data: {
                    phone_number: phone_number,
                    restaurant_id: restaurantData.data.id,
                },
                responseType: "arraybuffer",
            });
        }
        // eslint-disable-next-line
    }, []);

    return {
        startDownloadWalletCard,
        toggleLang,
        registerMember,
        fetchLoyaltyMember,
        fetchLoyaltyOrderAndTranscationList
    }
}